import React from "react";

function DOverdueSvgComponent(props: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
          <clipPath id="clip-path-overdue">
            <rect id="Rectangle_18424" data-name="Rectangle 18424" width="24" height="24" transform="translate(-18045 -774)" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="Mask_Group_431" data-name="Mask Group 431" transform="translate(18045 774)" clip-path="url(#clip-path-overdue)">
          <path id="downloading_FILL0_wght300_GRAD0_opsz24" d="M12.118-7.333a9.642,9.642,0,0,1-3.53-1.061,10.048,10.048,0,0,1-2.823-2.2,10.1,10.1,0,0,1-1.873-3.058,9.821,9.821,0,0,1-.679-3.635,9.692,9.692,0,0,1,2.548-6.7,9.708,9.708,0,0,1,6.383-3.253v1.577a8.332,8.332,0,0,0-5.264,2.82,8.146,8.146,0,0,0-2.086,5.553A8.157,8.157,0,0,0,6.875-11.73a8.3,8.3,0,0,0,5.243,2.82v1.577Zm2.108,0V-8.91A8.825,8.825,0,0,0,16.4-9.5a8.42,8.42,0,0,0,1.936-1.125L19.5-9.484A10.8,10.8,0,0,1,17-8.052,10.878,10.878,0,0,1,14.226-7.333Zm4.163-16.589a9.743,9.743,0,0,0-1.963-1.13,8.431,8.431,0,0,0-2.174-.6v-1.577a10.4,10.4,0,0,1,2.769.714A10.649,10.649,0,0,1,19.5-25.082l-1.111,1.16Zm2.586,12.914-1.111-1.124a8.284,8.284,0,0,0,1.107-1.932,9.084,9.084,0,0,0,.58-2.168h1.613a11.238,11.238,0,0,1-.735,2.776,9.5,9.5,0,0,1-1.454,2.448Zm.576-7.326a9.084,9.084,0,0,0-.58-2.168,8.284,8.284,0,0,0-1.107-1.932l1.131-1.144a10.357,10.357,0,0,1,1.44,2.468,10.718,10.718,0,0,1,.729,2.776Z" transform="translate(-18046.188 -744.717)" fill="#1a73e8"/>
        </g>
      </svg>
    </>
  );
}

export default DOverdueSvgComponent;
